import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/lib/axios";
import { API_PORTAL_URL } from "@/lib/config";

export const getAllActiveFAQ = createAsyncThunk(
  "FAQ/FindAllActiveFAQ",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/FAQ/FindAllActiveFAQ`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching FAQs:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// ─── SERVER (native fetch — call ONLY from Server Components / page.tsx) ────
export async function fetchAllActiveFAQ() {
  try {
    const res = await fetch(`${API_PORTAL_URL}/FAQ/FindAllActiveFAQ`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      next: { revalidate: 300 },
    });
    const json = await res.json();
    return json.Data ?? [];
  } catch {
    return [];
  }
}
